import { useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Typography, Box, Menu, MenuItem, Tooltip } from '@mui/material';
import { useSelector } from '../../redux/store';
import Iconify from '../iconify';
import { useUpdateOrderItemRedux } from '../../hooks/useUpdateOrderItemRedux';
import { useScopeCheck } from '../scopes';

SubCategory.propTypes = {
  row: PropTypes.object,
  disabled: PropTypes.bool
};

export default function SubCategory({ row, disabled = false }) {
  const { id = '' } = useParams();
  const updateOrderItemRedux = useUpdateOrderItemRedux();
  const hasAccess = useScopeCheck(['Edit-Order'], true);
  const { orderById } = useSelector((state) => state.orders || {});
  const { items = [], orderAgoraCategories = [], agoraSubcategories = [] } = orderById[id] || {};
  const currentCategoryId = row.agoraCategory?.id;
  const permittedCategoryIds = new Set(orderAgoraCategories.map((category) => category.id));
  const canEditCategories = hasAccess && items.every(
    (item) => item.agoraCategory?.id === 0 || permittedCategoryIds.has(item.agoraCategory?.id)
  );
  const tooltipTitle = !disabled && !canEditCategories
    ? 'You are not permitted to change categories in this order'
    : !disabled && row.categoryFromPunchoutDefualt && row.agoraSubcategory?.name
      ? 'Subcategory preselected based on previous punchouts'
      : !disabled ? row.agoraSubcategory?.name || '' : '';
  const [anchorEl, setAnchorEl] = useState(null);
  const open = canEditCategories && Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    };
  return (
    <>
      <Tooltip title={tooltipTitle} placement="top" arrow>
        {canEditCategories && !disabled ? (
          <Typography
            // color={stringToColor(row.agoraCategory?.name)}
            variant="subtitle2"
            sx={{
              border: 1,
              width: '125px',
              borderRadius: '3px',
              position: 'relative',
              display: 'flex', // Use flexbox
              alignItems: 'center',
              '&:hover': {
                cursor: 'pointer',
                backgroundColor: `#C4CDD5`,
              },
              my: '4px',
              py: '2px',
              px: 0.5,
            }}
            onClick={handleClick}
          >
            {row.categoryFromPunchoutDefualt && <Box mr={0.2}>
              <img src="/assets/bobAI/bobAIlogo_2.png" alt="bobAI Icon" style={{ width: 20, height: 20 }} />
            </Box>}
            <Box
              sx={{
                flexGrow: 1,
                overflow: 'hidden', // Hide overflow
                textOverflow: 'ellipsis', // Add ellipsis for overflow
                whiteSpace: 'nowrap', // Prevent wrapping
                pr: 2,
              }}
            >
              {row.agoraSubcategory?.name || ''}
            </Box>
            <Box>
              <Iconify icon={'mdi:chevron-down'} />
            </Box>
          </Typography>
        ) : (
          <Typography
            // color={stringToColor(row.agoraCategory?.name)}
            variant="subtitle2"
            sx={{
              border: 1,
              width: '125px',
              borderRadius: '3px',
              position: 'relative',
              display: 'flex', // Use flexbox
              alignItems: 'center',

              my: '4px',
              py: '5px',
              px: 0.5,
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                overflow: 'hidden', // Hide overflow
                textOverflow: 'ellipsis', // Add ellipsis for overflow
                whiteSpace: 'nowrap', // Prevent wrapping
                pr: 2,
              }}
            >
              {row.agoraSubcategory?.name || '\u00A0'}
            </Box>
          </Typography>
        )}
      </Tooltip>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {[...(agoraSubcategories || [])]
          .filter(
            (sub) =>
              //sub.mainCategoryId === subCategory.mainCategoryId
              sub.mainCategoryId === currentCategoryId
          )
          .sort((a, b) => (a?.name || '').localeCompare(b?.name || '', 'en', { sensitivity: 'base' }))
          .map((subCategory) => (
            <MenuItem
              key={subCategory?.id}
                  onClick={() => {
              updateOrderItemRedux(row?.id, 'agoraSubcategory', {
                id: subCategory?.id,
                name: subCategory?.name,
                mainCategoryId: subCategory.mainCategoryId,
              });
              if (row?.categoryFromPunchoutDefualt) updateOrderItemRedux(row?.id, 'categoryFromPunchoutDefualt', false);
              handleClose();
            }}
            >
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {subCategory?.name}
              </Typography>
            </MenuItem>
          ))}
      </Menu>
    </>
  );
}
